import {createBackendEditor, referenceActionData} from '../../form/ComponentEditor';
import OperationListEditor from './OperationListEditor';
import {postData} from "../../../utils/request";
import React from "react";
import isEqual from 'lodash-es/isEqual';
import Button from "../../form/Button";
import ConsignmentReceiptForm from "./Elements/ConsignmentReceiptForm";
import CheckBox from "../../form/CheckBox";
import {BarcodeFormatter, ProductSelect} from "../../../utils/formatters";
import {PriceView} from "../../classes/Price";

class ConsignmentReceiptEditor extends React.Component {

    state = {
        filtered: false,
        componentEditor: "ConsignmentReceipt",
        filter: [
            {column: "preset", value: "ConsignmentReceipt"},
            {column: "saved", value: 1}
        ],
        labels: {customer: "Partner"},
        actionButtons: [],
        actions: true,
        pool: {
            orderBy: {field: "displayname", direction: "ASC"},
            selection: {},
            labelKey: "displayname",
            optionsTemplate: ProductSelect,
            label: false,
            component: "OperationProductPoolItem",
            valueKey: "component_id",
            view: ["id","product_id","OperationList_id", "vat", "component_type", "component_id", ...PriceView("saleprice"), "saleprice", ...PriceView("listprice"), "listprice"],
            storeType: "remote",
            searchFormatter: BarcodeFormatter,
            placeholder: "Vonalkód vagy cím",
            onSourceItemUpdate: (value) => {
                value = {...value};
                value.component_type = "product";
                value.product_id = value.id;
                value.pickedqty = 1;
                return value;
            }
        }
    };

    promisedSetState = (newState) => {
        return new Promise((resolve) => {
            this.setState(newState, () => {
                resolve()
            });
        });
    }

    constructor(props) {
        super(props);
    }

    setFieldValue = (field, value) => {
        this.props.setFieldValue(field, value);
        if (field === "customer" && !isEqual(value, this.props.values.customer)) {
            this.props.setFieldValue("target", null);
        }
    }

    formatOperationItems = (config) => {
        config.visible = this.props.values && this.props.values.seller;
        return config;
    }

    getProps = () => {
        const props = {
            ...this.props,
            ...this.state,
            setFieldValue: this.setFieldValue,
        };
        props.actionButtons = [
            <Button key="4" disabled={ props.isLoading || !props.values.id } color="primary" icon={{lib: "fa", name: "truck"}} className="pull-right" onClick={ async (e) => {
                const values = props.values;
                values.autocheckup = true;
                await props.processAction(async () => {
                    const response = await postData({
                        action: 'OperationList.doAction',
                        actionname: 'create',
                        data: await referenceActionData(values, this.props.componentConfig)
                    });
                    await this.props.pristineForm(false);
                    return response;
                });
            }}>
                Bevételezés
            </Button>
        ];
        props.pool.parameters = {};
        props.pool.reqparams = {};
        if (props.values && props.values.seller) {
            props.pool.parameters.discount_type = "consignment";
            props.pool.parameters.OperationList_id = props.values.id;
            props.pool.parameters.seller = props.values.seller.partner_id;
            props.pool.parameters.customer = props.values.customer.partner_id;
        }
        props.pool.paginatorRight = <CheckBox onIcon={{lib: "fa", name: "box"}} offIcon={{lib: "fa", name: "box-open"}} value={1} checked={this.state.filtered} label={false} saveChanges={(field, value) => {
            this.setState({filtered: !!value});
        }} />;
        return props;
    }

    renderer = (componentProps) => {
        return <ConsignmentReceiptForm {...componentProps} />;
    }

    render() {
        const props = this.getProps();
        return <OperationListEditor {...props} renderer={this.renderer} formatOperationItems={this.formatOperationItems} />;
    }

}

export default createBackendEditor({
    componentName: "OperationList",
    WrappedComponent: ConsignmentReceiptEditor,
    editor: "ConsignmentReceipt",
    dirtyFlag: (values) => {
        return !parseInt(values.saved) && values.id;
    },
    props: {
        partnerType: "seller",
        componentActions: async (action, data, params, componentConfig) => {
            params.preset = "ConsignmentReceipt";
            data = await referenceActionData(data, componentConfig);
            return {action,data,params};
        }
    }
});